const information=[
    {
        title: 'Home',
        url:"/"
    },
    {
        title: 'About Us',
        url:"/about"
    },
    {
        title: 'Faqs',
        url:"/faqs"
    },
]

export default information